/**
 * Release notes manifest.
 * Each entry is a release note blurb shown to users in the app.
 * Add new entries to the TOP of the array (most recent first).
 */
export const releaseNotes = [
    {
        date: "2026-07-25",
        version: "0.19.1",
        content: `## What's New\n
        - **Customizable bottom tabs** — Rearrange the four main tabs from Settings to put your most-used sections one tap away.
        - **Add Screenshots to Feedback** — Attach screenshots when submitting feedback to help us understand your issue faster.
        - **Forms** - Create and manage custom forms using the form builder. Track entries, integrate with Paths (coming soon) for automation, and more.
        - **Files** - Upload and manage files in the Files section. Limit access to Folders using Roles.
        - **Bug fixes and improvements** — Various fixes regarding Task assignment, initial navigation after login, Board visibility, and more.
        `,
    },
    {
        date: "2026-07-07",
        version: "0.19",
        content: `## What's New\n
        - **Connect - Boards** — One way communication feature to share updates with various groups in your organization.
        - **Connect - Conversations** — Connect with others using group messaging.
        - **Bug Fixes** — Various bug fixes and improvements.
        - The Connect module is in a closed beta for a testing period and will be rolled out soon to everyone.
        `,
    },
    {
        date: "2026-06-30",
        version: "0.18",
        content: `## What's New\n
        - **iOS26 UI Refresh** — Native navigation components now use the iOS liquid glass effects.
        - **Fresh card look across the app** — Event, task, and small group cards now use soft shadows instead of hard borders for a cleaner, more modern feel.
        - **Android polish** — Text in input fields and search bars is now properly aligned, tab bar is no longer under software buttons, and modal headers no longer overlap the status bar.
        - **Smoother forms** — Tapping outside a text field while editing no longer causes unexpected keyboard behavior anywhere in the app.
        - **Contributions trends** — Filter the giving trends dashboard by method or fund to dig into exactly what you need.
        - **Web icon fixes** — Icons on the web version now render correctly across all pages.`,
    },
    {
        date: "2026-06-25",
        version: "0.17.1",
        content: `## What's New\n
        - **Schedule Trainings for a Term all at once** — Pick a date and teacher for each class in a module from one screen, then filter the schedule by term. Terms can be edited or deleted later.
        - **Assign teachers to training classes** — Each class instance can now have a teacher, who gets a day-before reminder. Teachers appear on the class detail and on the linked training task.
        - **Training tasks now link back to their class** — Training task cards and task detail screens show the linked class with a tap-through to the class instance.
        - **Assign volunteers right from the schedule grid** — Tap any cell in the task schedule to assign people inline without leaving the page. 
        - **People recently assigned to a task (in the last 6 months) are pinned to the top with a "Recent" badge when choosing assignees.
        - **Smarter assignment templates** — Applying a template now sends "you've been assigned" notifications to primary assignees, and only team assigners or admins can apply a template for their team.`,
    },
    {
        date: "2026-06-18",
        version: "0.17",
        content: `## What's New\n
        - Discover what's new anytime with the new **New Features & Fixes** section in the side menu.
        - Small groups now support **custom fields**, so you can track extra details like meeting preferences, childcare needs, or any data unique to your ministry.
        - Small group types can now have a custom **icon** to make them easier to spot.
        - When adding new people from the check-in screen, it will now check them in to the current location.
        - Profile permissions now split - limit access of Basic Info, Contact Info, and Custom Fields separately.`,
    },
];

export const getLatestReleaseNote = () => releaseNotes[0] || null;

export default releaseNotes;
